<button tdWbButton
        tdWbButtonType="icon"
        tdWbButtonSize="inline"
        [attr.aria-label]="('tdWb.newUser.signAgreement.HELP' | tdWbTranslate) + ' - ' + (label | tdWbTranslate)"
        [tdWbOverlayToggle]="newUserSignExchangeTooltip"
        tdWbOverlayPosition="start-top"
        tdWbOverlaySize="medium">
  <td-wb-icon iconId="tooltip--small"
              [inline]="true">
  </td-wb-icon>
</button>

<ng-template #newUserSignExchangeTooltip>
  <td-wb-overlay>
    <div class="td-wb-body-small" [innerHTML]="'tdWb.newUser.signAgreement.tooltip.PROFESSIONAL'  |tdWbTranslate"></div>
    <div class="td-wb-body-small" [innerHTML]="'tdWb.newUser.signAgreement.tooltip.ACCOUNT'  |tdWbTranslate"></div>
    <div class="td-wb-body-small" [innerHTML]="'tdWb.newUser.signAgreement.tooltip.ADDITIONAL_INFO'  |tdWbTranslate"></div>
  </td-wb-overlay>
</ng-template>
